'use client';

import { Header } from './layout/header';
import { MenuItem } from '@/lib/server-fetch';

interface HeaderWrapperProps {
  initialMenuData: MenuItem[];
}

export function HeaderWrapper({ initialMenuData }: HeaderWrapperProps) {
  return <Header initialMenuData={initialMenuData} />;
}

